module.exports = __webpack_public_path__ + "img/sdg_es_(17).14e9bda7.png";